// extracted by mini-css-extract-plugin
module.exports = {"root":"CarView_root__yLEka","_navigation":"CarView__navigation__FHd_d","_image":"CarView__image__Vu3Ks"};